import vuexI18n from 'vuex-i18n'
import config from './config'
import constant from './constant'
import address from './modules/address'
import api from './modules/api'
import auth from './modules/auth'
import access from './modules/access'
import message from './modules/message'
import shop from './modules/shop'
import userList from './modules/user-list'
import userNew from './modules/user-new'
import userDetail from './modules/user-detail'
import userEdit from './modules/user-edit'
import userPdf from './modules/user-pdf'
import usertype from './modules/usertype'
import usertypeNew from './modules/usertype-new'
import usertypeList from './modules/usertype-list'
import usertypeEdit from './modules/usertype-edit'
import domainNew from './modules/domain-new'
import domainList from './modules/domain-list'
import domainEdit from './modules/domain-edit'
import businesstypeNew from './modules/businesstype-new'
import businesstypeList from './modules/businesstype-list'
import businesstypeEdit from './modules/businesstype-edit'
import turnoverNew from './modules/turnover-new'
import turnoverList from './modules/turnover-list'
import turnoverEdit from './modules/turnover-edit'
import joinNew from './modules/join-new'
import joinList from './modules/join-list'
import joinEdit from './modules/join-edit'
import shopList from './modules/shop-list'
import shopNew from './modules/shop-new'
import shopEdit from './modules/shop-edit'
import shopDetail from './modules/shop-detail'
import shopUserList from './modules/shop/user-list'
import shopHistoryEdit from './modules/shophistory-edit'
import usertypeHistoryEdit from './modules/usertypehistory-edit'
import image from './modules/image'
import moralList from './modules/moral-list'
import moralNew from './modules/moral-new'
import moralEdit from './modules/moral-edit'
import moralResultList from './modules/moral-result-list'
import proposeList from './modules/propose-list'
import proposeDetail from './modules/propose-detail'
import proposeResult from './modules/propose-result'
import proposeTaskList from './modules/propose-task-list'
import proposeTaskNew from './modules/propose-task-new'
import proposeTaskDetail from './modules/propose-task-detail'
import proposeTaskDelete from './modules/propose-task-delete'
import proposeTaskUpdate from './modules/propose-task-update'
import deadlineNotice from './modules/deadline-notice'
import csvDownload from './modules/csv-download'
import rejectreason from './modules/rejectreason'
import rejectreasonNew from './modules/rejectreason-new'
import rejectreasonList from './modules/rejectreason-list'
import rejectreasonEdit from './modules/rejectreason-edit'
import guidelineNew from './modules/guideline-new'
import guidelineList from './modules/guideline-list'
import guidelineEdit from './modules/guideline-edit'
import guideline from './modules/guideline'
import shopManagerList from './modules/shop-manager-list'
import shopManagerEdit from './modules/shop-manager-edit'
import shiftCreatorList from './modules/shift-creator-list'
import shiftCreatorEdit from './modules/shift-creator-edit'
import shiftClass from './modules/shift-class'
import shiftCondition from './modules/shift-condition'
import shiftCreate from './modules/shift-create'
import shiftAttendance from './modules/shift-attendance'
import magazineList from './modules/magazine-list'
import magazineNew from './modules/magazine-new'
import magazineEdit from './modules/magazine-edit'
import humanStaffList from './modules/human-staff-list'
import willMust from './modules/will-must'
import referral from './modules/referral'
import introduction from './modules/introduction'
import question from './modules/question'
import normalQuestion from './modules/normal-question'
import abilityQuestion from './modules/ability-question'
import evaluateQuestion from './modules/evaluate-question'
import stepup from './modules/stepup'
import card from './modules/card'
import companyNotice from './modules/company-notice'
import supplier from './modules/supplier'
import consumableItems from './modules/consumable-items'
import category from './modules/category'
import shopConsumableItems from './modules/shop-consumable-items'
import holdPlace from './modules/hold-place'
import tanomail from './modules/tanomail'
import stockCheckPeriod from './modules/stock-check-period'
import shopOrders from './modules/shop-orders'
import shopOrderDetails from './modules/shop-order-details'
import masterServiceQuestion from './modules/master-service-question'
import serviceQuestion from './modules/service-question'
import serviceQuestionCategory from './modules/service-question-category'
import safetyConfirmation from './modules/safety-confirmation'
import movie from './modules/movie'
import area from './modules/area'

export default {
  state: {
    error: '',
    config: config,
    constant: constant
  },
  getters: {
    isSSL: state => {
      return state.config.protocol === 'https'
    },
    error: state => {
      return state.error
    },
    isSystemManagement: state => {
      var userAuthority = state.auth.user.userAuthority
      if (!userAuthority) {
        userAuthority = window.localStorage.getItem('user_authority')
      }
      return userAuthority === state.constant.userAuthority.system_management
    },
    isAppIncluding: state => {
      var userAuthority = state.auth.user.userAuthority
      if (!userAuthority) {
        userAuthority = window.localStorage.getItem('user_authority')
      }
      return userAuthority === state.constant.userAuthority.application_including
    },
    isAppNotIncluded: state => {
      var userAuthority = state.auth.user.userAuthority
      if (!userAuthority) {
        userAuthority = window.localStorage.getItem('user_authority')
      }
      return userAuthority === state.constant.userAuthority.application_not_included
    },
    isBrowsIncluding: state => {
      var userAuthority = state.auth.user.userAuthority
      if (!userAuthority) {
        userAuthority = window.localStorage.getItem('user_authority')
      }
      return userAuthority === state.constant.userAuthority.browsing_including
    },
    isShopMaster: state => {
      var isShopMaster = state.auth.user.shopMaster
      if (!isShopMaster) {
        isShopMaster = window.localStorage.getItem('is_shop_master')
      }
      return isShopMaster === state.constant.shopMaster.boss
    }
  },
  modules: {
    address: address,
    api: api,
    i18n: vuexI18n.store,
    auth: auth,
    access: access,
    message: message,
    shop: shop,
    userList: userList,
    userNew: userNew,
    userEdit: userEdit,
    userDetail: userDetail,
    userPdf: userPdf,
    usertype: usertype,
    usertypeNew: usertypeNew,
    usertypeList: usertypeList,
    usertypeEdit: usertypeEdit,
    domainNew: domainNew,
    domainList: domainList,
    domainEdit: domainEdit,
    turnoverNew: turnoverNew,
    turnoverList: turnoverList,
    turnoverEdit: turnoverEdit,
    businesstypeNew: businesstypeNew,
    businesstypeList: businesstypeList,
    businesstypeEdit: businesstypeEdit,
    joinNew: joinNew,
    joinList: joinList,
    joinEdit: joinEdit,
    shopList: shopList,
    shopNew: shopNew,
    shopEdit: shopEdit,
    shopDetail: shopDetail,
    shopUserList: shopUserList,
    shopHistoryEdit: shopHistoryEdit,
    usertypeHistoryEdit: usertypeHistoryEdit,
    image: image,
    moralList: moralList,
    moralNew: moralNew,
    moralEdit: moralEdit,
    moralResultList: moralResultList,
    proposeList: proposeList,
    proposeDetail: proposeDetail,
    proposeResult: proposeResult,
    proposeTaskList: proposeTaskList,
    proposeTaskNew: proposeTaskNew,
    proposeTaskDetail: proposeTaskDetail,
    proposeTaskDelete: proposeTaskDelete,
    proposeTaskUpdate: proposeTaskUpdate,
    deadlineNotice: deadlineNotice,
    csvDownload: csvDownload,
    rejectreason: rejectreason,
    rejectreasonNew: rejectreasonNew,
    rejectreasonList: rejectreasonList,
    rejectreasonEdit: rejectreasonEdit,
    guidelineNew: guidelineNew,
    guidelineList: guidelineList,
    guidelineEdit: guidelineEdit,
    guideline: guideline,
    shopManagerList: shopManagerList,
    shopManagerEdit: shopManagerEdit,
    shiftCreatorList: shiftCreatorList,
    shiftCreatorEdit: shiftCreatorEdit,
    shiftClass: shiftClass,
    shiftCondition: shiftCondition,
    shiftCreate: shiftCreate,
    shiftAttendance: shiftAttendance,
    magazineList: magazineList,
    magazineNew: magazineNew,
    magazineEdit: magazineEdit,
    humanStaffList: humanStaffList,
    willMust: willMust,
    referral: referral,
    introduction: introduction,
    question: question,
    normalQuestion: normalQuestion,
    abilityQuestion: abilityQuestion,
    evaluateQuestion: evaluateQuestion,
    stepup: stepup,
    card: card,
    companyNotice: companyNotice,
    supplier: supplier,
    consumableItems: consumableItems,
    category: category,
    shopConsumableItems: shopConsumableItems,
    holdPlace: holdPlace,
    tanomail: tanomail,
    stockCheckPeriod: stockCheckPeriod,
    shopOrders: shopOrders,
    shopOrderDetails: shopOrderDetails,
    masterServiceQuestion: masterServiceQuestion,
    serviceQuestion: serviceQuestion,
    serviceQuestionCategory: serviceQuestionCategory,
    safetyConfirmation: safetyConfirmation,
    movie: movie,
    area: area
  }
}



// WEBPACK FOOTER //
// ./src/store/index.js